var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _vm.isLearner
        ? _c(
            "v-card",
            { attrs: { flat: "", "max-height": "150" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-n8" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "5" } },
                    [
                      _c("v-select", {
                        staticClass: "mt-6",
                        attrs: {
                          items: _vm.learnerAuthorList,
                          "item-text": "learner",
                          dense: "",
                          label: "Learners",
                          "return-object": "",
                          outlined: "",
                          height: "30",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.learnerChange()
                          },
                        },
                        model: {
                          value: _vm.learnerAuthor,
                          callback: function ($$v) {
                            _vm.learnerAuthor = $$v
                          },
                          expression: "learnerAuthor",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.learnerAuthor
                    ? _c(
                        "v-col",
                        { staticClass: "mt-8 ml-n10" },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v("mdi-arrow-right-bold"),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "ml-2" }, [
                            _vm._v(
                              "Includes " +
                                _vm._s(_vm.learnerAuthor.author) +
                                " author(s)"
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.showAdditionalAuthors
                ? _c(
                    "v-row",
                    { staticClass: "mt-n8" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "8", align: "start" } },
                        [
                          _c("span", [_vm._v("Additional Authors")]),
                          _vm._v(" "),
                          !_vm.showAdditionalAuthors
                            ? _c(
                                "v-icon",
                                {
                                  attrs: { small: "", color: "green" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAdditionalAuthors = true
                                    },
                                  },
                                },
                                [_vm._v("mdi-plus")]
                              )
                            : _c(
                                "v-icon",
                                {
                                  attrs: { small: "" },
                                  on: {
                                    click: function ($event) {
                                      _vm.showAdditionalAuthors = false
                                    },
                                  },
                                },
                                [_vm._v("mdi-minus")]
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-col"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showAdditionalAuthors
                ? _c(
                    "v-row",
                    { staticClass: "mt-n8" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "5" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              transition: "scale-transition",
                              "append-icon": "mdi-delete",
                              type: "number",
                              dense: "",
                              label: "Authors",
                              min: "1",
                              outlined: "",
                            },
                            on: {
                              "click:append": function ($event) {
                                return _vm.resetAdditionalAuthors()
                              },
                              change: function ($event) {
                                return _vm.authorChange()
                              },
                            },
                            model: {
                              value: _vm.additionalAuthors,
                              callback: function ($$v) {
                                _vm.additionalAuthors = $$v
                              },
                              expression: "additionalAuthors",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-col"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _c(
            "v-card",
            { attrs: { flat: "", "max-height": "150" } },
            [
              _c(
                "v-row",
                { staticClass: "mt-n4" },
                [
                  _c("v-col", { attrs: { align: "end" } }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _c("v-col", [
                    _c("span", { staticClass: "input-label" }, [
                      _vm._v("Authors"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("v-col", { attrs: { align: "start" } }, [_vm._v(" ")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { staticClass: "mt-n6" },
                [
                  _c(
                    "v-col",
                    { attrs: { align: "end" } },
                    [
                      !_vm.isSilver
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onMinus()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-minus")])],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    [
                      _c("v-text-field", {
                        attrs: {
                          id: "quantity",
                          outlined: "",
                          dense: "",
                          disabled: _vm.isSilver,
                        },
                        on: { input: _vm.validateQuatity },
                        model: {
                          value: _vm.localQty,
                          callback: function ($$v) {
                            _vm.localQty = _vm._n($$v)
                          },
                          expression: "localQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { align: "start" } },
                    [
                      !_vm.isSilver
                        ? _c(
                            "v-btn",
                            {
                              attrs: { color: "primary", icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.onPlus()
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v("mdi-plus")])],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.error
                ? _c(
                    "v-row",
                    { staticStyle: { "background-color": "#FEFBFA" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "1" } },
                        [
                          _c("v-icon", { attrs: { small: "", color: "red" } }, [
                            _vm._v("mdi-alert-circle-outline"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-col", { attrs: { cols: "11", align: "start" } }, [
                        _c("span", { staticClass: "text-caption" }, [
                          _vm._v(_vm._s(_vm.error)),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.learner
                ? _c(
                    "v-row",
                    { staticClass: "mt-n8" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "8", align: "start" } },
                        [
                          _c("span", [_vm._v("Add Learners")]),
                          _vm._v(" "),
                          _c(
                            "v-icon",
                            {
                              attrs: { small: "", color: "green" },
                              on: {
                                click: function ($event) {
                                  return _vm.toLearner()
                                },
                              },
                            },
                            [_vm._v("mdi-plus")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-col"),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }